import { CDK_USER_TYPES } from '@/enums';
import { OriginalUserDataType } from '@/types';
import { jwtDecode } from 'jwt-decode';

export const checkIfUserIsAllowedToUseCDK = () => {
  const token = localStorage.getItem('accessToken');
  let user: OriginalUserDataType | null = null;
  try {
    if (token) user = jwtDecode(token) as OriginalUserDataType;
  } catch {
    user = null; // missing/malformed token → treat as not logged in
  }
  if (user && CDK_USER_TYPES.includes(user.type)) {
    return;
  }
  redirectToLoginInHub();
};

export const redirectToLoginInHub = () => {
  window.location.href = `${import.meta.env.VITE_HUB_URL}`;
};
